module.exports = __webpack_public_path__ + "static/img/x-level-3.5296dd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/x-level-3.svg
// module id = BBW0
// module chunks = 66